import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const navigate = useNavigate();
  const location = useLocation();

  // Handle scroll for navbar background
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      // Update active section based on scroll position
      const sections = document.querySelectorAll('section[id]');
      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 200;
        const sectionHeight = section.clientHeight;
        const sectionId = section.getAttribute('id');

        if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
          setActiveSection(sectionId);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    // If not on home page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // Already on home page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    closeMenu();
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container navbar-container">
        <Link to="/" className="navbar-brand" onClick={closeMenu}>
          <img src="/img/logo3.jpeg" alt="Growing Fields Organics" className="navbar-logo-img" />
          <span className="brand-name">Growing Fields Organics</span>
        </Link>

        <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <a
            href="#home"
            className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('home');
            }}
          >
            Home
          </a>

          <div className="nav-dropdown">
            <a
              href="#products"
              className={`nav-link ${activeSection === 'products' ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('products');
              }}
            >
              Products <span className="dropdown-arrow">▼</span>
            </a>
            <div className="dropdown-menu">
              <Link to="/product/normal-vermicompost" className="dropdown-item" onClick={closeMenu}>
                Vermicompost
              </Link>
              <Link to="/product/trichoderma-vermicompost" className="dropdown-item" onClick={closeMenu}>
                Trichoderma-Based Vermicompost
              </Link>
              <Link to="/product/premium-vermicompost" className="dropdown-item" onClick={closeMenu}>
                Premium Vermicompost
              </Link>
              <Link to="/product/coco-peat" className="dropdown-item" onClick={closeMenu}>
                Coco Peat
              </Link>
              <Link to="/product/potting-mixture" className="dropdown-item" onClick={closeMenu}>
                Potting Mixture
              </Link>
              <Link to="/product/vermiwash" className="dropdown-item" onClick={closeMenu}>
                Vermiwash
              </Link>
            </div>
          </div>

          <a
            href="#about"
            className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('about');
            }}
          >
            Our Story
          </a>

          <a
            href="#faqs"
            className={`nav-link ${activeSection === 'faqs' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('faqs');
            }}
          >
            FAQs
          </a>

          <a
            href="#contact"
            className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('contact');
            }}
          >
            Contact
          </a>
        </div>

        <div className={`menu-toggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
